<template>
  <div class="tab-text">
    <div>
      <section>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Logo</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div v-if="form.logo != null">
              <img :src="form.logo" :width="imageWidth" :height="imageHeight" />
            </div>
            <div
              v-if="!form.logo"
              class="default-upload"
              style="
                width: 300px;
                height: 158px;
                background-color: #f5f5f5;
                border-radius: 8px;
                position: relative;
              "
            >
              <vs-button
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                "
                color="dark"
                type="border"
                @click="chooseImage()"
              >
                <span>Upload</span>
              </vs-button>
            </div>
            <div
              class="grid-button-upload"
              style="
                margin-top: 8px;
                display: grid;
                grid-template-columns: repeat(2, min-content);
                grid-gap: 10px;
              "
            >
              <!-- secondary / border  >> btn-->
              <vs-button
                v-if="form.logo"
                color="dark"
                type="border"
                icon="autorenew"
                style="display: flex"
                @click="chooseImage()"
              >
                <span>Change</span>
              </vs-button>
              <input
                id="file-upload-img"
                @change="onUploadImages()"
                type="file"
                ref="fileImage"
                :accept="acceptFile"
              />
              <vs-button
                v-if="form.logo"
                color="dark"
                type="border"
                icon="delete_forever"
                style="display: flex"
                @click="popupActivo = true"
              >
                Remove
              </vs-button>
              <vs-popup
                classContent="popup-confirm"
                title="Confirm Delete"
                :active.sync="popupActivo"
              >
                <div>Are you sure you want to delete the image?</div>
                <div class="wrap-button">
                  <vs-button
                    color="dark"
                    type="border"
                    style="font-size: 12px !important"
                    @click="popupActivo = false"
                  >
                    No
                  </vs-button>
                  <vs-button
                    color="primary"
                    style="font-size: 12px !important"
                    @click="removeposter"
                  >
                    Yes
                  </vs-button>
                </div>
              </vs-popup>
            </div>
            <!-- <div> -->
            <!-- <vs-upload
                                v-if="!uploadSeller"
                                :multiple="false"
                                :automatic="true"
                                :single-upload="true"
                                :action="posterUploadUrl"
                                :fileName="`logo`"
                                :limit="1"
                                :data="posterData"
                                :headers="posterUploadHeader"
                                @change="successPosterUpload"
                            /> -->
            <!-- <vs-upload
                                v-if="!form.logo || changeImage"
                                :multiple="false"
                                :automatic="true"
                                :single-upload="true"
                                :fileName="`logo`"
                                :limit="1"
                                @change="successPosterUpload"
                                @on-delete="deleteFileLogo"
                                accept="image/png, image/jpeg, image/jpg, image/webp"
                            /> -->
            <!-- <vs-upload
                                v-else
                                :multiple="false"
                                :automatic="true"
                                :single-upload="true"
                                :fileName="`logo`"
                                :limit="1"
                                @change="successLogoUpload"
                                @on-delete="deleteFileLogo"
                            /> -->
            <!-- <div
                                class="grid-button-upload"
                                v-if="form.logo || showBtn"
                            >
                                <vs-button
                                color="dark"
                                type="flat"
                                icon="autorenew"
                                style="display: flex"
                                @click="changeImagePoster()"
                                >
                                Change
                                </vs-button>
                                <vs-button
                                color="dark"
                                type="flat"
                                icon="delete_forever"
                                style="display: flex"
                                @click="removeposter()"
                                >
                                Remove
                                </vs-button>
                            </div> -->
            <!-- </div> -->
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Name</span>
            <div style="font-size: 0.75rem; color: #aaa">
              Seller/Organizer Name
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.name" :maxLength="60" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Event Domain Name</span>
            <div style="font-size: 0.75rem; color: #aaa">
              The domain you want to use. We will setup a subdomain as
              book.yourdomain.com
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="{
                required: true,
                regex:
                  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
              }"
              name="domain"
              class="w-full"
              v-model="form.domain"
            />
            <span class="text-danger text-sm" v-show="errors.has('domain')">
              {{ splitError(errors.first("domain"), " domain") }}
            </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Username</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ form.s ? form.s : "-" }}
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Timezone</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-select
              v-model="form.timezone"
              :options="timezones"
            ></b-form-select>
          </div>
        </div>
      </section>
      <hr />
      <section>
        <h1 class="py-5">Confirmations & Tickets</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Email Sender Name</span>
            <div style="font-size: 0.75rem; color: #aaa">
              Must be Alpha-numeric characters that represent the company or
              brand
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.emailfromname" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Email Sender Email</span>
            <div style="font-size: 0.75rem; color: #aaa">
              This will be used as "From" email for sending out confirmation and
              ticket emails
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="{ regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }"
              name="email"
              class="w-full"
              v-model="form.emailfromemail"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">
              {{ errors.first("email") }}
            </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>SMS Sender Name</span>
            <div style="font-size: 0.75rem; color: #aaa">
              Limited to 11 characters only, without any space. Currently
              supported in Thailand Only.
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="{ max: 11 }"
              :maxlength="11"
              v-if="role === 'so-admin'"
              name="smssender"
              class="w-full"
              v-model="form.smssender"
              onkeypress="return /^[0-9]*\.?[a-zA-Z0-9]*$/i.test(event.key)"
            />
            <div v-else>
              {{ form.smssender ? form.smssender : "-" }}
            </div>
            <span class="text-danger text-sm" v-show="errors.has('smssender')">
              {{ errors.first("smssender") }}
            </span>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="role === 'so-admin'">
          <div class="vx-col sm:w-1/3 w-full">
            <span>SMS Gateway Username</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.smsuser" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="role === 'so-admin'">
          <div class="vx-col sm:w-1/3 w-full">
            <span>SMS Gateway Password</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.smspass" type="password" />
          </div>
        </div>
      </section>
      <hr />
      <section>
        <h1 class="py-5">Contact Channels</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Support Phone No.</span>
            <div style="font-size: 0.75rem; color: #aaa">
              A phone number for attendees to call for support
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              name="supportno"
              class="w-full"
              v-model="form.supportno"
              onkeypress="return /^[0-9+]/i.test(event.key)"
              onpaste="return false"
            />
            <span class="text-danger text-sm" v-show="errors.has('supportno')">
              {{ splitError(errors.first("supportno"), "supportno") }}
            </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Facebook Page</span>
            <div style="font-size: 0.75rem; color: #aaa">
              You can get this from the URL of your Facebook Page
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.fbpage" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>LINE ID</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.lineid" />
          </div>
        </div>
      </section>
      <hr />
      <section v-if="role === 'so-admin'">
        <h1 class="py-5">E-commerce</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>E-commerce Domain</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.domain_ec" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Default Courier</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.defaultcourier" />
          </div>
        </div>
      </section>
    </div>
    <div style="height: 10px"></div>
    <div class="vx-row pt-5 mt-5">
      <div class="vx-col w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="validateForm">Submit</vs-button>
        <vs-button
          v-if="showSellerCancel"
          class="mr-3 mb-2"
          type="border"
          @click="canceled"
          >Cancel
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import Service from "@/services";

import { timezones } from "@/utils/Timezones";
import { mapState } from "vuex";

const dict = {
  form: {
    folder: {
      required: "Please enter username",
    },
    timezones: {
      required: "Please select timezone",
    },
    supportno: {
      required: "Please enter support number",
    },
  },
};

Validator.localize("en", dict);
export default {
  props: ["form", "e", "role"],
  data() {
    return {
      popupActivo: false,
      posterUploadUrl:
        process.env.VUE_APP_API_URL +
        "/events/" +
        this.$route.query.e +
        "/merchant/upload",
      posterUploadHeader: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken,
      },
      posterData: {
        type: "poster",
      },
      timezones: timezones,
      showSellerCancel: false,
      uploadSeller: false,
      logo: "",
      changeImage: false,
      showBtn: false,
      imageWidth: 0,
      imageHeight: 0,
      LogoUpdate: null,
      acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    };
  },
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
    }),
  },
  methods: {
    splitError(val, word) {
      if (!val) {
        return;
      } else {
        const data = val.split(word);
        return data[0] + data[1];
      }
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submitBasic();
        } else {
          // form have errors
        }
      });
    },
    submitBasic() {
      const path = this.$route.path.includes("/sellers/");

      if (path) {
        this.form.logo = this.logo;
        this.$emit("submitBasic", this.form);
      } else {
        this.$vs.loading();
        const formData = new FormData();
        const dataKeyForms = Object.keys(this.form);
        for (let index = 0; index < dataKeyForms.length; index++) {
          const key = dataKeyForms[index];
          const value = this.dataKeyForms[key];
          formData.append(key, value);
        }

        Service.Event.saveMerchant(formData, this.e)
          .then((res) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success",
            });
          })
          .catch((e) => {
            this.$vs.loading.close();
          });
      }
    },

    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    successPosterUpload(res, file) {
      this.logo = file[0];
      this.changeImage = false;
      this.showBtn = true;
      this.updateLogo();
      // Service.Event.get({ ...this.form, e: this.e })
      // .then(res => {
      //     this.form = res.data.event.merchant;
      //     this.e = res.data.event.slug;
      // })
      // .catch(e => {
      //     /* this.$router.push("/pages/error-404").catch(() => {}); */
      // });
      // this.$vs.notify({
      //     color: "success",
      //     title: "Upload Success",
      //     text: "Poster upload success!"
      // });
    },
    changeImagePoster() {
      this.changeImage = true;
      this.showBtn = true;
    },
    removeposter() {
      this.form.logo = null;
      const merchantId = {
        id: this.$route.params.merchant_id,
      };
      this.form.s = this.s;
      const formData = new FormData();
      const dataKeyForms = Object.keys(this.form);
      for (let index = 0; index < dataKeyForms.length; index++) {
        const key = dataKeyForms[index];
        const value = this.form[key] === null ? "" : this.form[key];
        formData.append(key, value);
      }
      formData.append("remove", "logo");
      formData.append("s", this.s);
      formData.append("e", this.e);

      Service.Merchant.updateMerchant(formData, merchantId.id)
        .then((res) => {
          // this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          this.popupActivo = false;
        })
        .catch((e) => {
          this.$vs.loading.close();
        });
    },
    updateLogo() {
      this.form.logo = this.logo;
      const merchantId = {
        id: this.$route.params.merchant_id,
      };
      this.form.s = this.s;
      const formData = new FormData();
      // const dataKeyForms = Object.keys(this.form);
      // for (let index = 0; index < dataKeyForms.length; index++) {
      //     const key = dataKeyForms[index];
      //     const value = this.form[key]  === null ? '': this.form[key];
      //     formData.append(key, value);
      // }
      formData.append("s", this.form.s);
      formData.append("merchant_id", this.form.merchant_id);
      formData.append("logo", this.logo);
      Service.Merchant.updateMerchant(formData, merchantId.id)
        .then((res) => {
          console.log(res, "res upload");
          this.changeImage = false;
          this.form.logo = res.data.logo;
          // this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
        })
        .catch((e) => {
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push("/sellers");
    },
    successLogoUpload(res, file) {
      this.logo = file[0];
      console.log(this.logo, "this.logo");
    },
    deleteFileLogo(res) {
      if (res) {
        this.form.logo = null;
      }
    },
    chooseImage() {
      document.getElementById("file-upload-img").click();
    },
    onUploadImages() {
      this.logo = this.$refs.fileImage.files[0];
      this.form.logo = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.form.logo = reader.result;

        this.updateLogo(this.logo);
        // this.posterUpdate = reader.result
        this.setImageSize();
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
    },
  },
  mounted() {
    this.setImageSize();
    this.showSellerCancel = this.$route.path.includes("/sellers/")
      ? true
      : false;
    this.uploadSeller = this.$route.path.includes("/sellers/") ? true : false;
  },
};
</script>
<style lang="scss" scoped>
.grid-button-upload {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, min-content);
  grid-gap: 10px;
}
.vs-button {
  font-size: 10px !important;
}

input[type="file"] {
  display: none !important;
}
.popup-confirm {
  & div {
    width: 100%;
    text-align: center;
  }
  & .wrap-button {
    display: grid;
    grid-template-columns: repeat(2, 25%);
    grid-gap: 8px;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
</style>
